import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconVip = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
    ref={ref}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99975 2.34766C8.31455 2.34766 8.61393 2.4839 8.82071 2.72125L8.8672 2.78139L11.221 6.22359L13.5929 4.42026L13.6711 4.37398C14.0345 4.19184 14.4692 4.22707 14.7985 4.46537C15.0899 4.67626 15.2561 5.01526 15.2494 5.36829L15.2387 5.50112L14.4647 11.3364C14.4261 11.6272 14.1991 11.8518 13.9164 11.8938L13.8203 11.9009H2.1791C1.88576 11.9009 1.63322 11.7054 1.55441 11.4307L1.53475 11.3364L0.760981 5.50257C0.703747 5.102 0.873163 4.70261 1.20106 4.46536C1.53039 4.22707 1.96496 4.19184 2.32834 4.37396L2.38102 4.40349L2.4307 4.43778L4.77804 6.22359L7.14873 2.75852L7.17878 2.72127C7.38556 2.48391 7.68495 2.34766 7.99975 2.34766ZM7.99904 3.81559L5.72677 7.14071C5.55415 7.39229 5.28367 7.56061 4.98198 7.60391C4.72666 7.64054 4.46812 7.58536 4.25313 7.45201L4.14949 7.37889L2.11504 5.83059L2.74804 10.6006H13.25L13.882 5.83259L11.8525 7.37814C11.6506 7.53898 11.3993 7.62215 11.1439 7.61534L11.0161 7.60438C10.7574 7.56678 10.5224 7.43781 10.3521 7.24318L10.2726 7.1405L7.99904 3.81559Z"
      fill="currentColor"
    />
  </svg>
)

export const IconVip = forwardRef(_IconVip)
